export enum ViewType {
  CLASSIC = 'CLASSIC',
  LIST = 'LIST',
  COLUMNS = 'COLUMNS'
}
